<template>
  <div class="box">
    <div class="top">
      <div class="top-a"></div>
      <p class="top-b">报障科室分析</p>
    </div>
    <div class="bottom">
      <Table
        :row-class-name="rowClassName"
        :columns="columns"
        :data="data"
        :loading="loading"
      >
      </Table>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      loading: false,
      columns: [
        {
          title: "排名",
          key: "ranking",
        },
        {
          title: "科室名称",
          key: "name",
        },
        {
          title: "工单数量",
          key: "total",
        },
        {
          title: "占比",
          key: "percentage",
        },
      ],
      data: [],
    };
  },
  created() {
    this.loadHomeData();
  },
  methods: {
    rowClassName(row, index) {
      if (index === 0) {
        return "demo-one";
      } else if (index === 1) {
        return "demo-two";
      } else if (index === 2) {
        return "demo-three";
      }
      return "";
    },
    loadHomeData() {
      this.loading = true;
      let q = { begin: "2018-01-01 00:00:00", end: "3000-01-01 00:00:00" };
      $utils.api.load("/admin/statistics/deskCountNew", q, "GET").then((res) => {
        if (res.data) {
          this.data = res.data || {};
        }
        this.loading = false;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.box {
  width: 100%;
  padding: 10px;
}
.top {
  display: flex;
  height: 20px;
  margin-bottom: 10px;
  .top-a {
    width: 10px;
    height: 100%;
    background-color: #46a6ff;
  }
  .top-b {
    margin-left: 7px;
    font-weight: 600;
    color: black;
  }
}
.middle {
  width: 100%;
  display: flex;
  margin-bottom: 10px;
  .middle-a {
    margin-right: 8px;
  }
  .middle-b {
    margin-right: 8px;
  }
  .middle-c {
    .middle-ca {
      margin-right: 8px;
    }
  }
}
/deep/.ivu-table .demo-one td {
  color: red;
}
/deep/.ivu-table .demo-two td {
  color: #ffc621;
}
/deep/.ivu-table .demo-three td {
  color: blue;
}
</style>
